// extracted by mini-css-extract-plugin
export default {"root":"TopOptions_root__-Mdlw","chip":"TopOptions_chip__DIg+b"};